import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
import { toastService } from "../../utils/toastify";
const initialState = {
  adminData: {},
  profileData: {},
  loading: false,
  token: null,
};
export const adminLogin = createAsyncThunk(
  "admin/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/adminLogin", payload);
      console.log({ response });
      if (response?.data?.code == 200) {
        localStorage.setItem("adminLogin", JSON.stringify(response?.data));
        toastService.success(response?.data?.message);
        return response.data;
      } else {
        toastService.error(response?.data?.message);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      toastService.error(error?.response?.data?.message);
      rejectWithValue(error);
    }
  }
);
export const emailSent = createAsyncThunk(
  "admin/eamilsent",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/sentEmail", payload);
      if (response?.data?.code == 200) {
        toastService.success(response?.data?.message);
        return response.data;
      } else {
        toastService.error(response?.data?.message);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      toastService.error(error?.response?.data?.message);
      rejectWithValue(error);
    }
  }
);
export const resetPassword = createAsyncThunk(
  "admin/restPassword",
  async (payload, { rejectWithValue }) => {
    console.log({ payload });

    try {
      const { token, password } = payload;

      const response = await axiosInstance.put(`/setPassword?token=${token}`, {
        password,
      });
      if (response?.data?.code == 200) {
        toastService.success(response?.data?.message);
        return response.data;
      } else {
        toastService.error(response?.data?.message);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      toastService.error(error?.response?.data?.message);
      rejectWithValue(error);
    }
  }
);
export const changePassword = createAsyncThunk(
  "admin/restPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`changePassword`, payload);
      if (response?.data?.code == 200) {
        toastService.success("password updated successfully");
        return response.data;
      } else {
        toastService.error("password updated failed");
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      toastService.error(error?.response?.data?.message);
      rejectWithValue(error);
    }
  }
);
export const updateProfile = createAsyncThunk(
  "admin/updateProfile",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`editProfile`, payload);
      if (response?.data?.code == 200) {
        return response.data;
      } else {
        console.log(response);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      toastService.error(error?.response?.data?.message);
      rejectWithValue(error);
    }
  }
);
export const viewProfile = createAsyncThunk(
  "admin/viewProfile",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`viewProfile`);
      if (response?.data?.code == 200) {
        return response.data;
      } else {
        console.log(response);
        return rejectWithValue(response?.data);
      }
    } catch (error) {
      toastService.error(error?.response?.data?.message);
      rejectWithValue(error);
    }
  }
);
const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  extraReducers: (builder) => {
    builder.addCase(adminLogin.pending, (state) => {
      state.loading = true;
      return state;
    });
    builder.addCase(adminLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.adminData = action.payload;
    });
    builder.addCase(adminLogin.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(viewProfile.pending, (state) => {
      state.loading = true;
      return state;
    });
    builder.addCase(viewProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.profileData = action.payload;
    });
    builder.addCase(viewProfile.rejected, (state, action) => {
      state.loading = false;
    });
  },
});
export default authSlice.reducer;
